var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeverage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "path-1",
    points: "0 0.0169357944 5.99824 0.0169357944 5.99824 9 0 9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile---Event-Details",
    transform: "translate(-34.000000, -2512.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(35.000000, 2513.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9,
    cy: 9,
    r: 9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(6.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9992,0.924471223 C2.16416,2.13903263 0.6384,4.58727824 0.6384,5.69447122 C0.6384,7.12166421 1.69744,8.28289228 2.9992,8.28289228 C4.30096,8.28289228 5.36,7.12183964 5.36,5.69447122 C5.36,4.58727824 3.83424,2.13903263 2.9992,0.924471223 M2.9992,8.98306771 C1.34544,8.98306771 1.11022302e-14,7.50780456 1.11022302e-14,5.69447122 C1.11022302e-14,3.99903263 2.46736,0.524295785 2.74864,0.133067714 C2.85792,-0.0186164961 3.05864,-0.0444586014 3.196976,0.07536596 C3.216512,0.0922782407 3.234176,0.111646662 3.2496,0.133067714 C3.53104,0.523769469 5.99824,3.99833087 5.99824,5.69447122 C5.9984,7.50780456 4.65312,8.98306771 2.9992,8.98306771",
    id: "Fill-1",
    fill: "#979797",
    mask: "url(#mask-2)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeverage);
export default __webpack_public_path__ + "static/media/Beverage.8c5f297f7d5eebdd34e642efe639361d.svg";
export { ForwardRef as ReactComponent };